var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3Radiator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 20a4 4 0 11-8 0 4 4 0 018 0zm-11-3v42a4 4 0 01-4 4H10a4 4 0 01-4-4V17a4 4 0 014-4h46a4 4 0 014 4zm-44 0h-6v42h6V17zm10 0h-6v42h6V17zm10 0h-6v42h6V17zm10 0h-6v42h6V17zm10 0h-6v42h6V17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Radiator.64f670a1.svg";
export { SvgB3Radiator as ReactComponent };